 
import _ from 'underscore'

import CONSTANT from '../constant/activity'
import service from '../service/activity'

export default {
  getHomeActStatus ({ commit }) {
    return new Promise((resolve, reject) => {
      return service.getHomeActStatus().then((data) => {
        commit(CONSTANT.ACTIVITY_GET_HOMESTATUS_SUCCESS, data)
        return resolve(data)
      }, e => {
        commit(CONSTANT.ACTIVITY_GET_HOMESTATUS_ERROR)
        return reject(e)
      })
    })
  },
  getHomeFloatBanner({ commit }) {
    return new Promise((resolve, reject) => {
      return service.getHomeFloatBanner().then((data) => {
        commit(CONSTANT.ACTIVITY_GET_HOME_FLOATBANNER_SUCCESS, data)
        return resolve(data)
      }, e => {
        commit(CONSTANT.ACTIVITY_GET_HOME_FLOATBANNER_ERROR)
        return reject(e)
      })
    })
  },
  getUUGRoupActList({ commit }, info) {
    return new Promise((resolve, reject) => {
      return service.getUUGRoupActList(info).then((res) => {
        const data = {
          pageIndex: info.pageNum,
          data: res.list,
        }
        commit(CONSTANT.ACTIVITY_GET_UUG_ACT_LIST_SUCCESS, data)
        return resolve(data)
      }, e => {
        commit(CONSTANT.ACTIVITY_GET_UUG_ACT_LIST_ERROR)
        return reject(e)
      })
    })
  },
  getUUGRoupActDetail({ commit }, id) {
    return new Promise((resolve, reject) => {
      return service.getUUGRoupActDetail(id).then((data) => {
        commit(CONSTANT.ACTIVITY_GET_UUG_ACT_DETAIL_SUCCESS, data)
        return resolve(data)
      }, e => {
        commit(CONSTANT.ACTIVITY_GET_UUG_ACT_DETAIL_ERROR)
        return reject(e)
      })
    })
  },
  getUUGRoupActGroupList({ commit }, info) {
    return new Promise((resolve, reject) => {
      return service.getUUGRoupActGroupList(info).then((data) => {
        commit(CONSTANT.ACTIVITY_GET_UUG_ACT_GROUP_LIST_SUCCESS, data)
        return resolve(data)
      }, e => {
        commit(CONSTANT.ACTIVITY_GET_UUG_ACT_GROUP_LIST_ERROR)
        return reject(e)
      })
    })
  },
  getUUGroupActGroupDetail({ commit }, info) {
    return new Promise((resolve, reject) => {
      return service.getUUGroupActGroupDetail(info).then((data) => {
        commit(CONSTANT.ACTIVITY_GET_UUG_ACT_GROUP_DETAIL_SUCCESS, data)
        return resolve(data)
      }, e => {
        commit(CONSTANT.ACTIVITY_GET_UUG_ACT_GROUP_DETAIL_ERROR)
        return reject(e)
      })
    })
  },
}
